// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__PolicyChangePage__noTopMargin{margin-top:unset}[id*=inlineNotification] p{margin-bottom:-10px!important}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/gw-capability-policychange-common-react/pages/PolicyChanges/PolicyChangePage.module.scss"],"names":[],"mappings":"AAAA,oCACI,gBAAA,CAGJ,2BACI,6BAAA","sourcesContent":[".noTopMargin {\n    margin-top: unset;\n}\n\n[id*=\"inlineNotification\"] p {\n    margin-bottom: -10px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"noTopMargin": "app__PolicyChangePage__noTopMargin"
};
export default ___CSS_LOADER_EXPORT___;
